import React from 'react';
import BottomSection from '../components/BottomSection';
import franchise1 from '../assets/images/franchise-01.png';
import franchise2 from '../assets/images/franchise-02.png';
import franchise3 from '../assets/images/franchise-03.png';
import franchise4 from '../assets/images/franchise-04.png';
import franchiseFeeIcon from '../assets/images/franchise-icons/franchise-fee-icon.png';
import franchiseInventoryIcon from '../assets/images/franchise-icons/franchise-inventory-icon.png';
import franchiseDepositIcon from '../assets/images/franchise-icons/franchise-deposit-icon.png';
import { useSeo } from '../seo';

const franchisePolicyItems = [
  { icon: franchiseFeeIcon, value: '2.68W', label: '加盟费' },
  { icon: franchiseInventoryIcon, value: '8W', label: '起货盘' },
  { icon: franchiseDepositIcon, value: '1W', label: '保证金' },
];

function FranchisePage() {
  useSeo('franchise');

  return (
    <main className="join-us-page">
      <section className="join-us-section">
        <img className="join-us-image" src={franchise1} alt="价探招商加盟页面展示一" />
      </section>

      <section className="join-us-section news-title-section" style={{ marginTop: '3%' }}>
        <div className="franchise-overlay franchise-advantages-heading">
          <header className="home-section-heading">
            <h2>核心优势</h2>
            <p>Core Advantages</p>
          </header>
        </div>
      </section>

      <section className="join-us-section franchise-visual-section" style={{ marginTop: '-1%' }}>
        <img className="join-us-image" src={franchise2} alt="价探招商加盟页面展示二" />
      </section>

      <section className="join-us-section franchise-visual-section">
        <img className="join-us-image" src={franchise3} alt="价探招商加盟页面展示三" />
        <div className="franchise-overlay franchise-policy-heading">
          <h2>加盟政策</h2>
        </div>
        <div className="franchise-policy-grid">
          {franchisePolicyItems.map((item) => (
            <div className="franchise-policy-item" key={item.label}>
              <img className="franchise-policy-icon" src={item.icon} alt="" aria-hidden="true" />
              <span className="franchise-policy-value">{item.value}</span>
              <span className="franchise-policy-label">{item.label}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="join-us-section news-title-section" style={{ marginTop: '3%' }}>
        <div className="franchise-overlay franchise-contact-heading">
          <header className="home-section-heading">
            <h2>加盟咨询</h2>
            <p>Franchise Policy</p>
          </header>
        </div>
      </section>

      <section className="join-us-section franchise-visual-section" style={{ marginTop: '-2%' }}>
        <img className="join-us-image" src={franchise4} alt="价探招商加盟页面展示四" />
        <div className="franchise-contact-grid">
          <div className="franchise-contact-item">
            <h3>加盟热线</h3>
            <p>4001-727-117</p>
          </div>
        </div>
      </section>

      <BottomSection />
    </main>
  )
}

export default FranchisePage;
